// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"4e0fa3ea","204":"e2d709e8","412":"563f6c29","438":"c0d7e116","623":"aaef4fee","743":"680ce84a","795":"fd98c092","820":"e9268408","875":"e78a4499"}[chunkId] + ".chunk.js";
};